var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcBoxGray(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_130_1037)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.292 4.45949C23.5008 4.54283 23.6799 4.68683 23.8061 4.87292C23.9323 5.05901 23.9998 5.27864 24 5.50349V18.4965C23.9998 18.7213 23.9323 18.941 23.8061 19.1271C23.6799 19.3131 23.5008 19.4571 23.292 19.5405L12.417 23.8905C12.1488 23.9977 11.8497 23.9977 11.5815 23.8905L0.7065 19.5405C0.497953 19.4569 0.319208 19.3128 0.193291 19.1267C0.0673734 18.9407 5.22899e-05 18.7212 0 18.4965L0 5.50349C5.22899e-05 5.27882 0.0673734 5.05931 0.193291 4.87324C0.319208 4.68717 0.497953 4.54306 0.7065 4.45949L11.1645 0.275986L11.1705 0.274486L11.5815 0.109486C11.8501 0.00183483 12.1499 0.00183483 12.4185 0.109486L12.8295 0.274486L12.8355 0.275986L23.292 4.45949ZM21.231 5.24999L12 8.94299L2.769 5.24999L1.5 5.75849V6.35849L11.25 10.2585V22.1415L12 22.4415L12.75 22.1415V10.26L22.5 6.35999V5.75999L21.231 5.25149V5.24999Z",
    fill: "#28A8E0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_130_1037"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBoxGray);
export default __webpack_public_path__ + "static/media/ic_box_gray.f1831e697f10c44016a835f8eefee28b.svg";
export { ForwardRef as ReactComponent };